import { useTranslation } from "react-i18next";
import MPagination from "../m-pagination/MPagination";
import Spinner from "../spinner/spinner";
import { memo } from "react";

const DEFAULT_PAGE_SIZE = 10;

function MTable({
  columns,
  data,
  pageSize = DEFAULT_PAGE_SIZE,
  total = 0,
  currentPage,
  setCurrentPage,
  foundTitle,
  buttons,
  trimAmount,
  loading = false,
  uniqueKey,
  withTotal = true,
  title,
  cellClassName = "",
  wrapperClassName = "",
  rowsClassName = "",
  getRowClassName,
}) {
  const { t } = useTranslation();
  const found = foundTitle || t("general.table.found");

  const getScreenModeClasses = (column) => {
    if (column.showForModes) {
      const showModesClasses = column.showForModes
        ?.map((mode) => `${mode}:table-cell`)
        ?.join(" ");
      return `hidden ${showModesClasses}`;
    }
    return "";
  };

  return (
    <div
      className={`border-collapse overflow-x-auto tablet:overflow-hidden ${wrapperClassName}`}
    >
      <Spinner spinning={loading}>
        {withTotal && (
          <div className="text-base font-bold mb-4">
            {`${found}:`} <span className="text-green-500">{total}</span>
          </div>
        )}
        {title && <h3 className={"font-bold text-[18px]"}>{title}</h3>}
        <table className="w-full my-2 font-medium">
          <thead
            className={`text-gray4 text-sm border-b border-b-gray3  ${
              pageSize === Infinity && "table w-full table-fixed"
            }`}
          >
            <tr className={"space-x-4"}>
              {columns?.map((col) => {
                return (
                  <td
                    key={col.key + col.label}
                    className={`py-2 pr-3 ${getScreenModeClasses(col)} ${
                      col.className || ""
                    }`}
                  >
                    {col.label_render ? col.label_render() : col.label}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={`${
              pageSize === Infinity &&
              "max-h-[200px] overflow-y-auto table-fixed w-full"
            }`}
          >
            {data?.map((record, index) => (
              <tr
                className={`border-b border-b-gray3 space-x-4 w-full ${rowsClassName} ${
                  pageSize === Infinity && "table table-fixed"
                } ${getRowClassName ? getRowClassName(record) : ""}`}
                key={record[uniqueKey] || index}
              >
                {columns?.map((col) => {
                  return (
                    <td
                      key={col.label + col.key}
                      className={`py-3 px-2 ${getScreenModeClasses(
                        col
                      )} pl-0 ${cellClassName} ${
                        col.className || ""
                      } overflow-hidden whitespace-nowrap text-ellipsis max-w-[200px] truncate`}
                    >
                      {col.render ? col.render(record, index) : record[col.key]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex flex-col tablet:flex-row desktop:flex-row items-center w-full justify-between gap-8 mt-8">
          {buttons}
          {total > 0 && (
            <MPagination
              totalCount={total}
              pageSize={pageSize}
              setCurrent={setCurrentPage}
              currentPage={currentPage}
            />
          )}
        </div>
      </Spinner>
    </div>
  );
}

export default memo(MTable);
